<template>
  <img src="/images/kwelite2.png" alt="KW Elite, Realtors - Keller Williams">
</template>

<script>
export default {
  name: 'Logo'
}
</script>
